import http from './http'

export function getCashiers() {
  return http.get('cashier').then((res) => res.data)
}

export function createCashier(data) {
  return http.post('cashier', data).then((res) => res.data)
}

export function updateCashier(id, data) {
  return http.put(`cashier/${id}`, data).then((res) => res.data)
}

export function deleteCashier(id) {
  return http.delete(`cashier/${id}`).then((res) => res.data)
}
